import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const ScoreCards = () => {
  const dataPoints = useSelector((state) => state.bookings.dataPoints);
  const { label, value, rawDataPointLink } = dataPoints;

  return (
    <div data-testid="scorecards" className="scorecards">
      <DataDisplay value={value} label={label} url={rawDataPointLink} disableAnimation />
    </div>
  );
};
